import type LivePreviewHandler from '../schema/LivePreviewHandler';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { callEditorApi } from 'owa-editor/lib/utils/callApi';

export default function createLivePreviewHandler<T>(
    viewState: EditorViewState,
    onSelect: (value: T) => void
): LivePreviewHandler<T> {
    return {
        startPreview: (value: T) => {
            const isInShadowEdit = callEditorApi(viewState, 'isInShadowEdit');

            // If editor is already in shadow edit, no need to check again.
            // And the check result may be incorrect because the content is changed from last shadow edit and the cached selection path won't apply
            const range = !isInShadowEdit && callEditorApi(viewState, 'getSelectionRange');

            if (isInShadowEdit || (range && !range.collapsed)) {
                callEditorApi(viewState, 'startShadowEdit');
                onSelect(value);
            }
        },
        stopPreview: () => {
            callEditorApi(viewState, 'stopShadowEdit');
        },
    };
}
